import styled from '@emotion/styled/macro';

const FIELD_TITLE_WIDTH = 150;
const FIELD_VALUE_WIDTH = 290;
const FIELD_GAP = 20;

export const FormRow = styled.div(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: FIELD_GAP,
}));

export const FieldTitle = styled.div<{ fullLength?: boolean }>((props) => ({
  minWidth: props.fullLength ? 'auto' : FIELD_TITLE_WIDTH,
  maxWidth: props.fullLength ? 'auto' : FIELD_TITLE_WIDTH,
  fontFamily: props.theme.fonts.primary,
  fontSize: 13,
  fontWeight: 400,
  lineHeight: '16px',
  color: props.theme.colors.inactive,
  display: 'flex',
  alignItems: 'center',
}));

export const FieldValue = styled.div<{ width?: string }>((props) => ({
  width: props.width ? props.width : FIELD_VALUE_WIDTH,
  display: 'flex',
  alignItems: 'center',
  fontFamily: props.theme.fonts.primary,
  fontSize: 13,
  fontWeight: 400,
  lineHeight: '16px',
  color: props.theme.colors.primary,
}));

export const DelimiterWrapper = styled.div(() => ({
  width: FIELD_TITLE_WIDTH + FIELD_GAP + FIELD_VALUE_WIDTH,
}));
